import { useQuery } from "@tanstack/react-query";
import api, { formatDate } from "@/lib/api";
import { PageHeader, Table } from "@/admin/ui";

export default function AuditLogs() {
  const { data } = useQuery({
    queryKey: ["admin-audit"],
    queryFn: async () => (await api.get("/admin/audit-logs")).data,
  });

  return (
    <div data-testid="admin-audit-page">
      <PageHeader title="Audit Logs" sub="Every admin action, recorded for accountability" />
      <Table headers={["Actor", "Action", "Target", "Details", "When"]}>
        {(data?.items || []).map((log: any) => (
          <tr key={log.id}>
            <td className="px-4 py-2.5 text-gray-300 text-xs">{log.actor_email}</td>
            <td className="px-4 py-2.5"><span className="font-mono text-xs text-[#00E5FF]">{log.action}</span></td>
            <td className="px-4 py-2.5 font-mono text-xs text-gray-500">{log.target_type || "—"}</td>
            <td className="px-4 py-2.5 font-mono text-[10px] text-gray-500 max-w-[280px] truncate">
              {log.meta && Object.keys(log.meta).length ? JSON.stringify(log.meta) : "—"}
            </td>
            <td className="px-4 py-2.5 font-mono text-xs text-gray-500">{formatDate(log.created_at)}</td>
          </tr>
        ))}
      </Table>
    </div>
  );
}
